(function(){
var R = window.henuaRoutes || {};
var drawer, overlay, body, foot, closeBtn, lastFocused, addError, updateError, networkError, loadingText, updatedText, statusEl;
var sectionId = 'henua-cart-drawer';
var lines = Object.create(null);
var activeLine = null;
var newestHtml = '';
var lastAction = null;
var sequence = 0;
var subtotalCents = null;
var moneyFormat = '';
var queueError = null;

function $(id){ return document.getElementById(id); }

function setBadge(count){
var badge = $('henua-cart-count');
if(!badge) return;
badge.textContent = String(count);
badge.hidden = !(count > 0);
}

function message(text){
if(!body) return;
var old = body.querySelector('.hn-cart-message');
if(old) old.remove();
if(!text) return;
var p = document.createElement('p');
p.className = 'hn-cart-message';
p.setAttribute('role','alert');
p.textContent = text;
body.insertBefore(p, body.firstChild);
}

function formatMoney(cents){
if(!Number.isFinite(cents) || !moneyFormat) return null;
var token = moneyFormat.match(/\{\{\s*(amount_no_decimals_with_comma_separator|amount_with_comma_separator|amount_no_decimals|amount)(?:_with_currency)?\s*\}\}/);
if(!token) return null;
var type = token[1], amount = cents / 100, decimals = 2, thousands = ',', decimal = '.';
if(type.indexOf('no_decimals') !== -1) decimals = 0;
if(type.indexOf('comma_separator') !== -1){ thousands = '.'; decimal = ','; }
var value = amount.toFixed(decimals).split('.');
value[0] = value[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
var rendered = decimals ? value[0] + decimal + value[1] : value[0];
return moneyFormat.replace(token[0], rendered);
}

function setSubtotal(){
if(!body) return;
var total = subtotalCents, count = 0, valid = Number.isFinite(subtotalCents);
Object.keys(lines).forEach(function(key){
var line = lines[key];
if(!Number.isFinite(line.unitPrice) || !Number.isFinite(line.serverQty) || !Number.isFinite(line.desiredQty)){ valid = false; return; }
total += (line.desiredQty - line.serverQty) * line.unitPrice;
count += line.desiredQty;
});
setBadge(count);
if(!valid || !foot) return;
var value = formatMoney(total);
var target = foot.querySelector('.hn-cart-subtotal-value');
if(value !== null && target) target.textContent = value;
}

function apply(html, focus){
var doc = new DOMParser().parseFromString(html, 'text/html');
var nb = doc.getElementById('hn-cart-body');
var nf = doc.getElementById('hn-cart-foot');
var data = doc.getElementById('hn-cart-data');
if(nb) body.innerHTML = nb.innerHTML;
if(nf) foot.innerHTML = nf.innerHTML;
lines = Object.create(null);
if(data){
setBadge(parseInt(data.getAttribute('data-count'), 10) || 0);
subtotalCents = parseInt(data.getAttribute('data-subtotal-cents'), 10);
moneyFormat = data.getAttribute('data-money-format') || '';
}
if(nb) nb.querySelectorAll('.hn-cart-item[data-key]').forEach(function(source){
var key = source.getAttribute('data-key');
var targetRow = null;
Array.prototype.some.call(body.querySelectorAll('.hn-cart-item[data-key]'), function(candidate){ if(candidate.getAttribute('data-key') === key){ targetRow=candidate; return true; } return false; });
lines[key] = { key:key, serverQty:parseInt(source.getAttribute('data-qty'),10)||0, desiredQty:parseInt(source.getAttribute('data-qty'),10)||0, unitPrice:parseInt(source.getAttribute('data-unit-price'),10), row:targetRow, timer:null, version:0, error:null };
});
if(focus) restoreFocus(focus.key, focus.kind);
}

function parseLines(html){
var doc = new DOMParser().parseFromString(html, 'text/html');
var parsed = Object.create(null);
doc.querySelectorAll('.hn-cart-item[data-key]').forEach(function(row){
var key = row.getAttribute('data-key');
parsed[key] = { qty:parseInt(row.getAttribute('data-qty'),10)||0, price:parseInt(row.getAttribute('data-unit-price'),10) };
});
var data = doc.getElementById('hn-cart-data');
return { lines:parsed, subtotal:data ? parseInt(data.getAttribute('data-subtotal-cents'),10) : NaN, count:data ? parseInt(data.getAttribute('data-count'),10)||0 : 0 };
}

function refreshHtml(){
return fetch(R.cart + '?sections=' + sectionId, { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
.then(function(r){ if(!r.ok) throw new Error(updateError || 'No se pudo actualizar el carrito.'); return r.json(); })
.then(function(j){ var html = j && j[sectionId]; if(!html) throw new Error(updateError || 'No se pudo actualizar el carrito.'); return html; });
}

function refresh(){
return refreshHtml().then(function(html){ newestHtml = html; apply(html, lastAction); lastAction = null; });
}

function post(url, payload){
return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(payload) })
.then(function(r){
return r.text().then(function(text){
var data;
try { data = JSON.parse(text); } catch(err) { throw { message: updateError || 'No se pudo actualizar el carrito.' }; }
if(!r.ok) throw data;
return data;
});
});
}

function responseHtml(data){
return data && data.sections && data.sections[sectionId] ? Promise.resolve(data.sections[sectionId]) : refreshHtml();
}

function errorText(err, fallback){
if(err instanceof TypeError) return networkError || fallback;
var text = err && (err.description || err.message);
if(text && /^(no se pudo|no hay|no queda|cantidad|stock|producto|el producto|la cantidad)/i.test(text)) return text;
if(text && /stock|inventory|available|quantity|limit|sold out/i.test(text)) return fallback;
return fallback;
}

function say(text){ if(statusEl){ statusEl.textContent = ''; setTimeout(function(){ statusEl.textContent = text || ''; }, 30); } }
function busy(on){ if(drawer){ if(on) drawer.setAttribute('aria-busy','true'); else drawer.removeAttribute('aria-busy'); } }

function restoreFocus(key, kind){
if(!body) return;
var row = null;
Array.prototype.some.call(body.querySelectorAll('.hn-cart-item[data-key]'), function(candidate){ if(candidate.getAttribute('data-key') === key){ row = candidate; return true; } return false; });
var target = row ? row.querySelector(kind === 'plus' ? '.hn-cart-qty-plus' : (kind === 'minus' ? '.hn-cart-qty-minus' : '.hn-cart-item-remove')) : null;
if(!target) target = body.querySelector('.hn-cart-item-remove') || foot.querySelector('.hn-cart-checkout, .hn-cart-continue') || body.querySelector('.hn-cart-empty a') || closeBtn;
if(target && target.focus) target.focus();
}

function setRowBusy(row, isBusy){ if(row) row.setAttribute('aria-busy', isBusy ? 'true' : 'false'); }
function paintLine(line){
if(!line || !line.row) return;
line.row.hidden = line.desiredQty === 0;
line.row.setAttribute('data-qty', String(line.desiredQty));
var value = line.row.querySelector('.hn-cart-qty-value');
if(value) value.textContent = String(line.desiredQty);
}

function hasPending(){
return Object.keys(lines).some(function(key){ var line=lines[key]; return line.timer !== null || line.desiredQty !== line.serverQty; });
}

function syncConfirmed(html){
var parsed = parseLines(html);
if(Number.isFinite(parsed.subtotal)) subtotalCents = parsed.subtotal;
setBadge(parsed.count);
Object.keys(lines).forEach(function(key){
var line = lines[key], actual = parsed.lines[key];
if(actual){ line.serverQty = actual.qty; if(Number.isFinite(actual.price)) line.unitPrice = actual.price; }
else line.serverQty = 0;
if(line.version === line.versionAtSend) line.desiredQty = line.serverQty;
});
}

function pendingLine(){
var keys = Object.keys(lines);
for(var i=0;i<keys.length;i++){
var line = lines[keys[i]];
if(line.timer === null && line.desiredQty !== line.serverQty) return line;
}
return null;
}

function finishQueue(){
if(activeLine || hasPending()) return;
busy(false);
Object.keys(lines).forEach(function(key){ setRowBusy(lines[key].row, false); });
if(newestHtml){ apply(newestHtml, lastAction); newestHtml = ''; lastAction = null; }
else setSubtotal();
if(queueError){ message(queueError); }
else message('');
say(queueError ? '' : updatedText);
}

function pump(){
if(activeLine) return;
var line = pendingLine();
if(!line){ finishQueue(); return; }
activeLine = line;
line.versionAtSend = line.version;
var sendQty = Math.max(0, Math.floor(Number(line.desiredQty) || 0));
line.desiredQty = sendQty;
sequence++;
var thisSequence = sequence;
busy(true);
setRowBusy(line.row, true);
say(loadingText);
post(R.cartChange, { id:line.key, quantity:sendQty, sections:sectionId })
.then(responseHtml)
.then(function(html){
if(thisSequence === sequence){ newestHtml = html; syncConfirmed(html); }
line.error = null;
queueError = null;
})
.catch(function(err){
line.error = errorText(err, updateError);
queueError = line.error;
return refreshHtml().then(function(html){
if(thisSequence === sequence){ newestHtml = html; syncConfirmed(html); }
}).catch(function(){
if(line.version === line.versionAtSend){ line.desiredQty = line.serverQty; paintLine(line); }
});
})
.finally(function(){
activeLine = null;
if(line.row) setRowBusy(line.row, false);
if(hasPending()) pump(); else finishQueue();
});
}

function optimistic(key, quantity, kind){
var line = lines[key];
if(!line) return;
var n = Number(quantity);
if(!Number.isFinite(n)) return;
line.desiredQty = Math.max(0, Math.floor(n));
line.version++;
line.error = null;
queueError = null;
lastAction = { key:key, kind:kind };
paintLine(line);
setRowBusy(line.row, true);
setSubtotal();
if(line.timer !== null) clearTimeout(line.timer);
line.timer = setTimeout(function(){ line.timer = null; pump(); }, 250);
}

function showSkel(){
if(!drawer || !body) return;
drawer.classList.add('is-adding');
if(body.querySelector('.hn-cart-skel')) return;
var sk = document.createElement('div');
sk.className = 'hn-cart-skel';
sk.setAttribute('aria-hidden','true');
sk.innerHTML = '<span class="hn-cart-skel-img"></span><span class="hn-cart-skel-lines"><i></i><i></i><i></i></span>';
body.insertBefore(sk, body.firstChild);
}
function hideSkel(){
if(!drawer || !body) return;
drawer.classList.remove('is-adding');
var sk = body.querySelector('.hn-cart-skel'); if(sk) sk.remove();
}

function add(variantId, qty){
busy(true); say(loadingText);
open(); showSkel();
return post(R.cartAdd, { items: [{ id: parseInt(variantId, 10), quantity: qty || 1 }], sections: sectionId })
.then(responseHtml).then(function(html){ newestHtml = html; hideSkel(); apply(html, null); message(''); busy(false); say(updatedText); })
.catch(function(err){ return refresh().catch(function(){}).then(function(){ hideSkel(); busy(false); message(errorText(err, addError)); throw err; }); });
}

function change(key, qty, row, kind){
if(row && lines[key]){ optimistic(key, qty, kind); return Promise.resolve(); }
var quantity = Number(qty);
if(!Number.isFinite(quantity)) return Promise.resolve();
quantity = Math.max(0, Math.floor(quantity));
busy(true); say(loadingText);
return post(R.cartChange, { id:key, quantity:quantity, sections:sectionId })
.then(responseHtml).then(function(html){ newestHtml=html; apply(html,{key:key,kind:kind}); message(''); busy(false); say(updatedText); })
.catch(function(err){ return refresh().catch(function(){}).then(function(){ busy(false); message(errorText(err, updateError)); restoreFocus(key,kind); say(updatedText); }); });
}

function getFocusable(){
return Array.prototype.slice.call(drawer.querySelectorAll('button, a[href]')).filter(function(el){ return el.offsetParent !== null; });
}
function trapFocus(e){
if(e.key !== 'Tab') return;
var f = getFocusable();
if(!f.length) return;
var first = f[0], last = f[f.length - 1];
if(e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); }
else if(!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
}
function onKeydown(e){ if(e.key === 'Escape') close(); else trapFocus(e); }

function open(){
if(!drawer || drawer.classList.contains('on')) return;
if(window.henuaToggleSearch) window.henuaToggleSearch(false);
if(window.henuaToggleMenu) window.henuaToggleMenu(false);
lastFocused = document.activeElement;
if(window.henuaLockScroll) window.henuaLockScroll();
drawer.classList.add('on'); overlay.classList.add('on'); drawer.setAttribute('aria-hidden', 'false');
document.addEventListener('keydown', onKeydown);
if(closeBtn) closeBtn.focus();
}
function close(){
if(!drawer || !drawer.classList.contains('on')) return;
drawer.classList.remove('on'); overlay.classList.remove('on'); drawer.setAttribute('aria-hidden', 'true');
document.removeEventListener('keydown', onKeydown);
if(window.henuaUnlockScroll) window.henuaUnlockScroll();
if(lastFocused && lastFocused.focus) lastFocused.focus();
}

function init(){
if(window.__henuaCartInitialized) return;
window.__henuaCartInitialized = true;
drawer = $('hn-cart-drawer'); overlay = $('hn-cart-overlay'); body = $('hn-cart-body'); foot = $('hn-cart-foot'); closeBtn = $('hn-cart-close');
var data = $('hn-cart-data');
addError = data ? data.getAttribute('data-add-error') : 'No se pudo agregar el producto.';
updateError = data ? data.getAttribute('data-update-error') : 'No se pudo actualizar el carrito.';
networkError = data ? data.getAttribute('data-network-error') : '';
loadingText = data ? data.getAttribute('data-loading') : '';
updatedText = data ? data.getAttribute('data-updated') : '';
statusEl = $('hn-cart-status');
if(!drawer) return;
var toggle = $('henua-cart-toggle');
if(toggle) toggle.addEventListener('click', function(e){ e.preventDefault(); open(); });
if(closeBtn) closeBtn.addEventListener('click', close);
if(overlay) overlay.addEventListener('click', close);
var initial = body.querySelectorAll('.hn-cart-item[data-key]');
initial.forEach(function(row){
var key=row.getAttribute('data-key'), qty=parseInt(row.getAttribute('data-qty'),10)||0;
lines[key]={key:key,serverQty:qty,desiredQty:qty,unitPrice:parseInt(row.getAttribute('data-unit-price'),10),row:row,timer:null,version:0,error:null};
});
subtotalCents = data ? parseInt(data.getAttribute('data-subtotal-cents'),10) : NaN;
moneyFormat = data ? data.getAttribute('data-money-format') || '' : '';
body.addEventListener('click', function(e){
var row=e.target.closest ? e.target.closest('.hn-cart-item') : null;
if(!row) return;
var key=row.getAttribute('data-key'), line=lines[key];
if(!line) return;
var qty=line.desiredQty;
if(e.target.closest('.hn-cart-qty-plus')) change(key,qty+1,row,'plus');
else if(e.target.closest('.hn-cart-qty-minus')) change(key,qty-1,row,'minus');
else if(e.target.closest('.hn-cart-item-remove')) change(key,0,row,'remove');
});
foot.addEventListener('click', function(e){ if(e.target.closest && e.target.closest('.hn-cart-service-links .hn-footer-link')) close(); });
}

window.HenuaCart = { add:add, change:change, refresh:refresh, open:open, close:close };
if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
